import React from 'react'
import { useKeyboardNavigationProps } from './DotNavigation.type'

const useKeyboardNavigation = ({
  length,
  focusedDot,
  selected,
  onSelect,
  dotRefs
}: useKeyboardNavigationProps) => {
  const focusDot = (index: number) => {
    const dot = dotRefs.current?.[index]?.current
    dot?.focus()
  }

  const backwardNavigation = () => {
    const nextIndex = focusedDot > 0 ? focusedDot - 1 : length - 1
    focusDot(nextIndex)
  }

  const forwardNavigation = () => {
    const nextIndex = focusedDot < length - 1 ? focusedDot + 1 : 0
    focusDot(nextIndex)
  }

  const leftArrowNavigation = () => {
    const nextIndex = selected > 0 ? selected - 1 : length - 1
    focusDot(nextIndex)
    onSelect(nextIndex)
  }

  const rightArrowNavigation = () => {
    const nextIndex = selected < length - 1 ? selected + 1 : 0
    focusDot(nextIndex)
    onSelect(nextIndex)
  }

  const handleKeyPress = (
    event: React.KeyboardEvent<HTMLDivElement>,
    index: number
  ) => {
    const actionsByKey = {
      ArrowLeft: backwardNavigation,
      ArrowRight: forwardNavigation,
      Enter: () => onSelect(index),
      ' ': () => onSelect(index)
    }

    if (event.key in actionsByKey) {
      actionsByKey[event.key as keyof typeof actionsByKey]()
    }
  }

  const handleLeftArrowKeyPress = (
    event: React.KeyboardEvent<HTMLDivElement>
  ) => {
    const actionsByKey = {
      Enter: leftArrowNavigation,
      ' ': leftArrowNavigation
    }

    if (event.key in actionsByKey) {
      actionsByKey[event.key as keyof typeof actionsByKey]()
    }
  }

  const handleRightArrowKeyPress = (
    event: React.KeyboardEvent<HTMLDivElement>
  ) => {
    const actionsByKey = {
      Enter: rightArrowNavigation,
      ' ': rightArrowNavigation
    }

    if (event.key in actionsByKey) {
      actionsByKey[event.key as keyof typeof actionsByKey]()
    }
  }

  return {
    leftArrowNavigation,
    rightArrowNavigation,
    handleKeyPress,
    handleLeftArrowKeyPress,
    handleRightArrowKeyPress
  }
}

export default useKeyboardNavigation
